export const AUTH_NAME_SEPARATOR = '.';
export const USERNAME_PART_SANITIZER = /[^a-zA-Z0-9]/g;

export const formatNamePart = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return '';
  
  return trimmed
    .split(' ')
    .filter(Boolean)
    .map(word => `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');
};

export const sanitizeUsernamePart = (value: string): string =>
  value.replace(USERNAME_PART_SANITIZER, '').trim();

export const splitAuthName = (authName: string): { firstName: string; surname: string } => {
  const trimmed = authName.trim();
  if (!trimmed) return { firstName: '', surname: '' };

  const separator = trimmed.includes(AUTH_NAME_SEPARATOR) ? AUTH_NAME_SEPARATOR : ' ';
  const parts = trimmed.split(separator).filter(Boolean);

  if (parts.length < 2) {
    return { firstName: formatNamePart(parts[0] ?? ''), surname: '' };
  }

  return {
    firstName: formatNamePart(parts[0]),
    surname: formatNamePart(parts.slice(1).join(' '))
  };
};

export const buildPreferredUsername = (firstName: string, surname: string, email: string): string => {
  const sanitizedFirst = sanitizeUsernamePart(firstName);
  const sanitizedSurname = sanitizeUsernamePart(surname);

  if (sanitizedFirst && sanitizedSurname) {
    return `${sanitizedFirst.toLowerCase()}${AUTH_NAME_SEPARATOR}${sanitizedSurname.toLowerCase()}`;
  }

  const emailPart = sanitizeUsernamePart(email.split('@')[0] ?? '');
  return emailPart.toLowerCase();
};